import { useMemo } from 'react'

import { useFetchBankAccounts } from './useFetchBankAccounts'

export const useBankAccount = (bankAccountId: string) => {
  const { bankAccounts } = useFetchBankAccounts()

  const bankAccount = useMemo(() => {
    return bankAccounts.find((ba) => ba.id === bankAccountId)
  }, [bankAccounts, bankAccountId])

  return { bankAccount }
}
